
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MenuItem } from "../types";

@Component
export default class SideNav extends Vue {
    @Prop() private name!: string;
    @Prop() private sub_name!: string;
    @Prop() private position!: string;
    @Prop() private menu?:MenuItem[];
    protected shouldShow: boolean = false;
    protected shouldShowList = ["design", "drawings", "video"];

    constructor() {
        super();
    }

    private checkShouldShow() {
        const currentRouteName = (this.$router as any).history.current.name;
        this.shouldShow = this.shouldShowList.indexOf(currentRouteName) === -1;
    }

    // ✅ 生命周期钩子
    mounted() {
        this.checkShouldShow();
    }

    @Watch("$route")
    onRouteChange(to: any, from: any) {
        this.checkShouldShow();  
    }

    private clearCache() {
        (window as any).clearPwaCache();
    };


    private swiper_prev(){
        $(".swiper-button-prev").click()
    };
    private swiper_next(){
        $(".swiper-button-next").click()
    };
    private goToHome() {
        if (this.$route.path !== '/') {
            this.$router.push('/');
        }
    }

}
